import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import NoDataMsg from 'library/noData';
import { ResponsiveContainer, Line, LineChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, BarChart, Bar } from "recharts";
import CheckInput from 'screens/components/basic/CheckInput';
import { formatNumbers } from 'utils/helpers';

const componentName = "SalesSummaryDetails";
class Body extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }

    }

    getNamesList = (name) => {
        let salesProfit = [
            { name: "Gross Sales", key: "totalGrossSales", format: "$" },
            { name: "Net Sales", key: "totalNetSales", format: "$" },
            { name: "Discounts", key: "totalDiscounts", format: "$" },
            { name: "Exact Costs", key: "totalExactCosts", format: "$" },
            { name: "Weighted Avg Costs", key: "totalWeightedAvgCosts", format: "$" },
            { name: "Refund Amount", key: "totalRefundAmount", format: "$" },
            { name: "Tax", key: "totalTax", format: "$" },
            { name: "Gross Profit", key: "totalGrossProfitExact", format: "$" },
            { name: "Gross Profit %", key: "totalGrossProfitPercent", format: "%" },
            { name: "Deposit Amount", key: "depositAmount", format: "$" },
            { name: "Items Sold (Gross)", key: "itemsSold", format: "none" },
            { name: "Invoices Sold (Gross)", key: "invoicesSold", format: "none" },
            { name: "Average Transaction", key: "averageTransaction", format: "$" },
            { name: "Shipping / Delivery", key: "shippingCost", format: "$" },
        ];
        let giftCard = [
            { name: "GiftCard Net Sales", key: "giftCardTotalSales", format: "$" },
            { name: "GiftCard Refunds", key: "giftCardRefunds", format: "$" },
            { name: "GiftCard Discounts", key: "giftCardDiscounts", format: "$" },
        ];
        let cannabisBreakdown = [
            { name: "Gross Sales", cannabisKey: "cannabisGrossSales", nonCannabisKey: "nonCannabisGrossSales", format: "$" },
            { name: "Net Sales", cannabisKey: "cannabisNetSales", nonCannabisKey: "nonCannabisNetSales", format: "$" },
            { name: "Discounts", cannabisKey: "cannabisDiscounts", nonCannabisKey: "nonCannabisDiscounts", format: "$" },
            { name: "Exact Costs", cannabisKey: "cannabisExactCosts", nonCannabisKey: "nonCannabisExactCosts", format: "$" },
            { name: "Weighted Avg Costs", cannabisKey: "cannabisWeightedAvgCosts", nonCannabisKey: "nonCannabisWeightedAvgCosts", format: "$" },
            { name: "Refund Amount", cannabisKey: "cannabisRefundAmount", nonCannabisKey: "nonCannabisRefundAmount", format: "$" },
            { name: "Tax", cannabisKey: "cannabisTax", nonCannabisKey: "nonCannabisTax", format: "$" },
            { name: "Gross Profit", cannabisKey: "cannabisGrossProfitExact", nonCannabisKey: "nonCannabisGrossProfitExact", format: "$" },
        ];
        let taxBreakdown = [
            { name: "Total Tax", key: "totalTax", format: "$" },
            { name: "PST", key: "totalPST", format: "$" },
            { name: "GST", key: "totalGST", format: "$" },
            { name: "PST Vape", key: "totalPST_Vape", format: "$" },
            { name: "HST", key: "totalHST", format: "$" },
            { name: "PST SK", key: "totalPST_SK", format: "$" },
        ];
        let orderTypeBreakdown = [
            { name: "Gross Sales", inStoreKey: "inStoreGrossSales", onlineKey: "onlineGrossSales", format: "$" },
            { name: "Invoices Sold (Gross)", inStoreKey: "inStoreInvoicesSold", onlineKey: "onlineInvoicesSold", format: "none" },
            { name: "% of Gross Sales", inStoreKey: "inStoreGrossSalesPercent", onlineKey: "onlineGrossSalesPercent", format: "%" }
        ]

        let nameList = []
        switch (name) {
            case "SalesProfit":
                nameList = salesProfit
                break;
            case "Tax":
                nameList = taxBreakdown
                break;
            case "Cannabis":
                nameList = cannabisBreakdown
                break;
            case "Giftcard":
                nameList = giftCard
                break;
            case "OrderType":
                nameList = orderTypeBreakdown
                break;
        }

        return nameList

    }

    generateSummaryRows = (data, detailsToGenerate, categoryFiltersSelected = false) => {
        let detailsList = this.getNamesList(detailsToGenerate)

        let outputList = [];

        switch (detailsToGenerate) {
            case "SalesProfit":
            case "Tax":
            case "Giftcard":
                detailsList.forEach(item => {
                    if (item.name != "Invoices Sold (Gross)" || (item.name == "Invoices Sold (Gross)" && !categoryFiltersSelected)) {
                        outputList.push(
                            <tr key={item.name}>
                                <td><b>{item.name}</b></td>
                                <td>{formatNumbers(data[`${item.key}`], item.format)}</td>
                            </tr>
                        )
                    }
                })
                break;
            case "Cannabis":
                detailsList.forEach(item =>
                    outputList.push(
                        <tr key={item.name}>
                            <td><b>{item.name}</b></td>
                            <td>{formatNumbers(data[`${item.cannabisKey}`], item.format)}</td>
                            <td>{formatNumbers(data[`${item.nonCannabisKey}`], item.format)}</td>
                        </tr>
                    )
                )
                break;
            case "OrderType":
                detailsList.forEach(item => {
                    if (item.name != "Invoices Sold (Gross)" || (item.name == "Invoices Sold (Gross)" && !categoryFiltersSelected)) {
                        outputList.push(
                            <tr key={item.name}>
                                <td><b>{item.name}</b></td>
                                <td>{formatNumbers(data[`${item.inStoreKey}`], item.format)}</td>
                                <td>{formatNumbers(data[`${item.onlineKey}`], item.format)}</td>
                            </tr>
                        )

                    }
                })

                break;
        }
        return outputList
    }

    generateDetailRows = (data, includeSalesProfit, includeGiftcard, includeCannabisBreakdown, includeTaxBreakdown, includeOrderTypeBreakdown, categoryFiltersSelected, orderTypeFiltersSelected) => {
        let salesProfit = this.getNamesList("SalesProfit");
        let giftCard = this.getNamesList("Giftcard");
        let cannabisBreakdown = this.getNamesList("Cannabis");
        let taxBreakdown = this.getNamesList("Tax");
        let orderTypeBreakdown = this.getNamesList("OrderType");
        let outputList = [];

        outputList.push(
            <tr key={data.date}>
                <td>
                    <div className="col-lg-12">
                        <h3>{moment(data.date).format('MMMM Do, YYYY')}</h3>
                    </div>
                </td>
                <td>
                    <div className="col-lg-12">
                        <table>
                            <thead>
                                <tr>
                                    <th className='tableHeaderColorGray'>Type</th>
                                    {
                                        salesProfit.map(item => {
                                            return (
                                                item.name != "Invoices Sold (Gross)" || (item.name == "Invoices Sold (Gross)" && !categoryFiltersSelected) ?
                                                    <th className='tableHeaderColorGray' key={item.name}>{item.name}</th> : null
                                            )
                                        })


                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {includeSalesProfit ?
                                    <tr>
                                        <td>Total</td>
                                        {
                                            salesProfit.map(item => {
                                                return (
                                                    item.name != "Invoices Sold (Gross)" || (item.name == "Invoices Sold (Gross)" && !categoryFiltersSelected) ?
                                                        <td className='purpleText' key={item.key}>{formatNumbers(data[`${item.key}`], item.format)}</td> : null
                                                )
                                            })
                                        }
                                    </tr> : null
                                }
                                {includeCannabisBreakdown && !categoryFiltersSelected ?
                                    <tr>
                                        <td>Cannabis</td>
                                        {
                                            cannabisBreakdown.map(item => <td className='purpleText' key={item.cannabisKey}>{formatNumbers(data[`${item.cannabisKey}`], item.format)}</td>)
                                        }
                                    </tr> : null
                                }
                                {includeCannabisBreakdown && !categoryFiltersSelected ?
                                    <tr>
                                        <td>NonCannabis</td>
                                        {
                                            cannabisBreakdown.map(item => <td className='purpleText' key={item.nonCannabisKey}>{formatNumbers(data[`${item.nonCannabisKey}`], item.format)}</td>)
                                        }
                                    </tr> : null
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="col-lg-12"><br /><br /></div>
                    {includeGiftcard ?
                        <div className="col-lg-6">
                            <table>
                                <thead>
                                    <tr>
                                        {
                                            giftCard.map(item => <th className='tableHeaderColorGray' key={item.name}>{item.name}</th>)
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        {
                                            giftCard.map(item => <td className='purpleText' key={item.key}>{formatNumbers(data[`${item.key}`], item.format)}</td>)
                                        }
                                    </tr>
                                </tbody>
                            </table>
                        </div> : null
                    }
                    {includeTaxBreakdown ?
                        <div className="col-lg-6">
                            <table>
                                <thead>
                                    <tr>
                                        {includeSalesProfit ?
                                            taxBreakdown.filter(item => item.key != "totalTax").map(item => <th className='tableHeaderColorGray' key={item.name}>{item.name}</th>)
                                            : taxBreakdown.map(item => <th className='tableHeaderColorGray' key={item.name}>{item.name}</th>)
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        {includeSalesProfit ?
                                            taxBreakdown.filter(item => item.key != "totalTax").map(item => <td className='purpleText' key={item.key}>{formatNumbers(data[`${item.key}`], item.format)}</td>)
                                            : taxBreakdown.map(item => <td className='purpleText' key={item.key}>{formatNumbers(data[`${item.key}`], item.format)}</td>)
                                        }
                                    </tr>
                                </tbody>
                            </table>
                        </div> : null
                    }
                    {includeOrderTypeBreakdown && !orderTypeFiltersSelected ?
                        <div className="col-lg-6">
                            <table>
                                <thead>
                                    <tr>
                                        <th className='tableHeaderColorGray'>Type</th>
                                        {
                                            orderTypeBreakdown.map(item => {
                                                return (
                                                    item.name != "Invoices Sold (Gross)" || (item.name == "Invoices Sold (Gross)" && !categoryFiltersSelected) ?
                                                        <th className='tableHeaderColorGray' key={item.name}>{item.name}</th> : null
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>In Store</td>
                                        {
                                            orderTypeBreakdown.map(item => {
                                                return (
                                                    item.name != "Invoices Sold (Gross)" || (item.name == "Invoices Sold (Gross)" && !categoryFiltersSelected) ?
                                                        <td className='purpleText' key={item.key}>{formatNumbers(data[`${item.inStoreKey}`], item.format)}</td> : null
                                                )
                                            })
                                        }
                                    </tr>
                                    <tr>
                                        <td>Online</td>
                                        {
                                            orderTypeBreakdown.map(item => {
                                                return (
                                                    item.name != "Invoices Sold (Gross)" || (item.name == "Invoices Sold (Gross)" && !categoryFiltersSelected) ?
                                                        <td className='purpleText' key={item.key}>{formatNumbers(data[`${item.onlineKey}`], item.format)}</td> : null
                                                )
                                            })
                                        }
                                    </tr>
                                </tbody>
                            </table>
                        </div> : null
                    }
                </td>
            </tr>

        )
        return outputList
    }


    render() {

        let salesSummaryDetails = this.props.salesSummaryDetails ? this.props.salesSummaryDetails.data : [];
        let beginDate = this.props.beginDate;
        let endDate = this.props.endDate;

        let summary = salesSummaryDetails ? salesSummaryDetails.filter(item => item.recordType == "Summary")[0] : null;
        let details = salesSummaryDetails ? salesSummaryDetails.filter(item => item.recordType == "Details") : []

        let detailsToInclude = this.props.detailsToIncludeOptions.map(item => item.value);

        let includeSalesProfit = detailsToInclude.includes("SalesProfit");
        let includeGiftcard = detailsToInclude.includes("Giftcard");
        let includeTaxBreakdown = detailsToInclude.includes("Tax");
        let includeCannabisBreakdown = detailsToInclude.includes("Cannabis");
        let includeOrderTypeBreakdown = detailsToInclude.includes("OrderType");

        let includeSalesChart = detailsToInclude.includes("ChartsSales");
        let includeTransAmountChart = detailsToInclude.includes("ChartTransAmount");
        let includeTransCountChart = detailsToInclude.includes("ChartsTransCount");

        let categoryFiltersSelected = this.props.salesSummaryDetails ? this.props.salesSummaryDetails.categoryFiltersSelected : false;
        let orderTypeFiltersSelected = this.props.salesSummaryDetails ? this.props.salesSummaryDetails.orderTypeFiltersSelected : false;

        return (
            <div className="row m-0">
                {
                    details.length <= 0 ?
                        //If there's NO DATA to display
                        <NoDataMsg />
                        :
                        details.length > 0 &&
                        //If there's DATA
                        <div>
                            <div className="row m-0">
                                <div className="text-center list_header">
                                    {beginDate ?
                                        <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                            {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                        : ""}
                                </div>
                            </div>
                            <div className="row justify-content-lg-center">
                                <div className="col-lg-12 title_summary">
                                    <h3 className="m-0 text-center text-justify">SUMMARY</h3>
                                </div>
                                {includeSalesProfit || includeGiftcard || includeOrderTypeBreakdown ?
                                    <div className="col-lg-6 col-xl-6">
                                        <table className="table table-striped table-hover table-responsive">
                                            <thead>
                                                <tr>
                                                    <th className="tableHeaderColorPurple"></th>
                                                    <th className="tableHeaderColorPurple">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {includeSalesProfit ? this.generateSummaryRows(summary, "SalesProfit", categoryFiltersSelected) : null}
                                                {includeGiftcard ? this.generateSummaryRows(summary, "Giftcard") : null}
                                            </tbody>
                                        </table>
                                        {
                                            includeOrderTypeBreakdown && !orderTypeFiltersSelected ?
                                                <table className="table table-striped table-hover table-responsive">
                                                    <thead>
                                                        <tr>
                                                            <th className="tableHeaderColorPurple"></th>
                                                            <th className="tableHeaderColorPurple">In Store</th>
                                                            <th className="tableHeaderColorPurple">Online</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.generateSummaryRows(summary, "OrderType", categoryFiltersSelected)}
                                                    </tbody>
                                                </table> : null
                                        }
                                    </div> : null
                                }
                                <div className="col-lg-6">
                                    {includeCannabisBreakdown && !categoryFiltersSelected ?
                                        <table className="table table-striped table-hover table-responsive">
                                            <thead>
                                                <tr>
                                                    <th className="tableHeaderColorPurple"></th>
                                                    <th className="tableHeaderColorPurple">Cannabis</th>
                                                    <th className="tableHeaderColorPurple">Non-Cannabis</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.generateSummaryRows(summary, "Cannabis")}
                                            </tbody>
                                        </table> : null
                                    }
                                    {includeTaxBreakdown ?
                                        <table className="table table-striped table-hover table-responsive">
                                            <thead>
                                                <tr>
                                                    <th className="tableHeaderColorPurple">Tax</th>
                                                    <th className="tableHeaderColorPurple">Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.generateSummaryRows(summary, "Tax")}
                                            </tbody>
                                        </table> : null
                                    }
                                </div>
                            </div>
                            <div className="row">
                                {includeSalesChart &&
                                    <div>
                                        <h3 className="text-center">Sales and Profits</h3>
                                        <div className="row">
                                            <div className="col-lg-2 col-md-2 col-sm-2 pt-1 pl-3">
                                                <CheckInput text="Gross Sales" value={true} name={`${componentName}_ShowGrossSales`} />
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-2 pt-1 pl-3">
                                                <CheckInput text="Net Sales" value={true} name={`${componentName}_ShowNetSales`} />
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-2 pt-1 pl-3">
                                                <CheckInput text="Tax" value={true} name={`${componentName}_ShowTax`} />
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-2 pt-1 pl-3">
                                                <CheckInput text="Discount" value={true} name={`${componentName}_ShowDiscount`} />
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-2 pt-1 pl-3">
                                                <CheckInput text="Gross Profit" value={true} name={`${componentName}_ShowGrossProfit`} />
                                            </div>
                                        </div>

                                        <div className="row mt-2 bg-light" >
                                            <ResponsiveContainer width="100%" height={300}>
                                                <LineChart data={details}>
                                                    <CartesianGrid />
                                                    <XAxis dataKey="date" tick={{ fontSize: 10 }} tickFormatter={value => moment(value).format('YYYY-MM-DD')} />
                                                    <YAxis tickFormatter={value => `$${value}`} />
                                                    <Tooltip labelFormatter={value => moment(value).format('YYYY-MM-DD')} formatter={value => `$${value}`} />
                                                    <Legend />
                                                    {this.props.showGrossSales ? <Line type="monotone" dataKey="totalGrossSales" stroke="#7a60e5" name="Gross Sales" /> : null}
                                                    {this.props.showNetSales ? <Line type="monotone" dataKey="totalNetSales" stroke="#009CE0" name="Net Sales" /> : null}
                                                    {this.props.showTax ? <Line type="monotone" dataKey="totalTax" stroke="#16A5A5" name="Tax" /> : null}
                                                    {this.props.showDiscount ? <Line type="monotone" dataKey="totalDiscounts" stroke="#68BC00" name="Discounts" /> : null}
                                                    {this.props.showGrossProfit ? <Line type="monotone" dataKey="totalGrossProfitExact" stroke="#B0BC00" name="Gross Profit" /> : null}
                                                </LineChart>
                                            </ResponsiveContainer>
                                            <br />
                                            <br />
                                        </div>
                                    </div>}
                                {includeTransAmountChart &&
                                    <div>
                                        <h3 className="text-center">Average Transaction Amount</h3>
                                        <div className="col-lg-12 mt-2 bg-light" >
                                            <ResponsiveContainer width="100%" height={300}>
                                                <BarChart data={details.map(x => ({ date: x.date, "Average": x.averageTransaction }))}>
                                                    <CartesianGrid />
                                                    <XAxis dataKey="date" tick={{ fontSize: 10 }} tickFormatter={value => moment(value).format('YYYY-MM-DD')} />
                                                    <YAxis tickFormatter={value => `$${value}`} />
                                                    <Tooltip labelFormatter={value => moment(value).format('YYYY-MM-DD')} formatter={value => `$${value}`} cursor={{ fill: "#D4D1FF20" }} />
                                                    <Bar dataKey="Average" fill="#7a60e5" />
                                                </BarChart>
                                            </ResponsiveContainer>
                                            <br />
                                            <br />
                                        </div>
                                    </div>

                                }
                                {includeTransCountChart &&
                                    <div>
                                        <h3 className="text-center">Number Of Transactions</h3>
                                        <div className="col-lg-12 mt-2 bg-light " >
                                            <ResponsiveContainer width="100%" height={300}>
                                                <BarChart data={details.map(x => ({ date: x.date, Count: x.invoicesSold }))}>
                                                    <CartesianGrid />
                                                    <XAxis dataKey="date" tick={{ fontSize: 10 }} tickFormatter={value => moment(value).format('YYYY-MM-DD')} />
                                                    <YAxis />
                                                    <Tooltip labelFormatter={value => moment(value).format('YYYY-MM-DD')} cursor={{ fill: "#D4D1FF20" }} />
                                                    <Bar dataKey="Count" fill="#7a60e5" />
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="row col-lg-12">
                                <table className="table table-striped table-hover table-responsive">
                                    <thead>
                                        <tr>
                                            <th className='tableHeaderColorGray'>Date</th>
                                            <th className='tableHeaderColorGray'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            details ? details.map(item => {
                                                return (
                                                    this.generateDetailRows(item, includeSalesProfit, includeGiftcard, includeCannabisBreakdown, includeTaxBreakdown, includeOrderTypeBreakdown, categoryFiltersSelected, orderTypeFiltersSelected)
                                                )
                                            }) : null
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                }
            </div>



        )


    }
};

const mapStateToProps = state => {
    return {
        showGrossSales: state.form.SalesSummaryDetails_ShowGrossSales,
        showNetSales: state.form.SalesSummaryDetails_ShowNetSales,
        showTax: state.form.SalesSummaryDetails_ShowTax,
        showDiscount: state.form.SalesSummaryDetails_ShowDiscount,
        showGrossProfit: state.form.SalesSummaryDetails_ShowGrossProfit
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Body);